<script>
	import { fly } from 'svelte/transition'
	import { onLoadImage } from '../util/util.js'

	let showContent

	export let background = ''
	export let headline = ''
	export let graphic = ''
	export let subHeadline = ''
	export let fullheight = false
	export let home = false

	let homeHeight = window.innerHeight

	let y, height

	let blur, scale, translate

	// $: willChange = y < height

	$: contentHeight = height * 0.77

	$: if (y < contentHeight) {
		updateHero()
	}

	function updateHero() {
		// amount to blur
		blur = Math.min(y / 60, 15)
		// rate that content scales down
		scale = 1 - y / 8000
		// rate that content moves down
		translate = y / -20
		// opacity of content
		// $: opacity = Math.max(1 - y / 1200, 0)
	}

	let setup = () => {
		if (graphic) {
			onLoadImage(graphic.url, () => (showContent = true))
		} else {
			showContent = true
		}
		setTimeout(updateHero, 30)
	}

	function scrollDown(e) {
		e.preventDefault()
		document.getElementById('main_content').scrollIntoView({
			behavior: 'smooth',
		})
	}
</script>

<svelte:window bind:scrollY={y} />

<section
	class="hero"
	class:fullheight
	class:hero-home={home}
	bind:clientHeight={height}
	style="background-image:url({background});min-height: {homeHeight}px"
	use:setup>
	<div
		class="hero-background"
		style="filter:blur({blur}px); background-image:url({background})" />
	<div class="hero-inner">
		<div class="main">
			{#if showContent}
				<div in:fly={{ y: 5, duration: 600 }}>
					<div
						class="inner-wrap"
						style="transform:scale({scale}) translateY({translate}px);
						filter:blur({y < contentHeight ? blur : 0}px); opacity: {y < contentHeight ? 1 : 0}">
						<h2>
							{headline}
							<span class="sr-only">The Tide</span>
						</h2>
						{#if graphic}
							<img src={graphic.url} alt={graphic.alt} />
						{/if}
						{#if subHeadline}
							<h3>{subHeadline}</h3>
						{/if}
					</div>
				</div>
			{/if}
		</div>
	</div>
	<a href="#main_content" class="scroll-btn" on:click={scrollDown}>
		<img src="/wp-content/uploads/2020/07/slider-arrow.png" alt="Scroll down" />
	</a>
</section>

<div style="height: {height}px" />
